import { createLayupClient } from './layupApiClient';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const sendEmail = async (data: any) => {
  const client = createLayupClient(false);
  const response = await client.post('/v1/emails', { data });
  return response.data;
};
